import { render, staticRenderFns } from "./VaIconResponsive.vue?vue&type=template&id=2ea1af93&"
import script from "./VaIconResponsive.vue?vue&type=script&lang=js&"
export * from "./VaIconResponsive.vue?vue&type=script&lang=js&"
import style0 from "./VaIconResponsive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports